<template>
  <article class="m-card-element m-card-element-design-2">
    <div class="m-card-element-info-data">
      <img
        v-if="producto.metadata.imagen"
        :alt="elementNombre"
        id="tarjetaImagen"
        :src="producto.metadata.imagen"
      >
      <img
        v-else
        :alt="elementNombre"
        id="tarjetaImagen"
        src="@/assets/img/ds2.png"
      >
      <h5>
        {{ producto.categoria.nombre }}
      </h5>
      <h2 class="m-card-element-design-2-name">
        {{ producto.nombre }}
      </h2>
    </div>
    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="producto.activo"
          key="available"
        >
          DISPONIBLE
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          NO DISPONIBLE
        </h3>
        <h4
          v-if="producto.visible"
          key="visible"
        >
          VISIBLE
        </h4>
        <h4
          v-else
          key="hidden"
        >
          OCULTO
        </h4>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyProductCard2',
  props: {
    producto: Object
  }
}
</script>
